import { z } from 'zod';
/**
 * CSV/XLSX exports (REQUIREMENTS §2.9): soldiers, assignments, inventory, the
 * full ledger — filterable by unit, date range, status, category.
 *
 * The server owns the rows and the column set; the file is the client's job.
 * One table shape serves both formats, so CSV and XLSX can never disagree
 * about what a column means, and the export is scoped exactly like the
 * screens it mirrors — `authz.ts`, not a second rule set.
 */
export const exportDatasetSchema = z.enum(['soldiers', 'assignments', 'inventory', 'ledger']);
export const EXPORT_MAX_ROWS = 10_000;
/** GET /api/exports/:dataset. Every filter is optional; unknown ones are rejected. */
export const exportQuerySchema = z
    .object({
    /** A platoon or team: the unit and everything under it. Must be within the caller's scope. */
    unitId: z.string().min(1).optional(),
    /** ISO datetimes: `from` inclusive, `to` exclusive. Applied to the dataset's own date (see columns). */
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    /** Dataset-specific: user status, assignment status, inventory status, or ledger type. */
    status: z.string().min(1).max(40).optional(),
    /** Catalog category. */
    category: z.string().min(1).max(80).optional(),
})
    .strict();
export const exportColumnSchema = z.object({
    key: z.string().min(1),
    he: z.string().min(1),
    en: z.string().min(1),
});
export const exportCellSchema = z.union([z.string(), z.number(), z.null()]);
export const exportResponseSchema = z.object({
    dataset: exportDatasetSchema,
    /** Server time the rows were read, ISO. */
    generatedAt: z.string(),
    columns: z.array(exportColumnSchema).min(1),
    /** One array per row, positionally aligned with `columns`. Dates are ISO strings. */
    rows: z.array(z.array(exportCellSchema)),
    /** True when more rows matched than EXPORT_MAX_ROWS; narrow the filters. */
    truncated: z.boolean(),
});
//# sourceMappingURL=exports.js.map